<template>
  <div class="footer-bg">
    <div class="ma-3 mx-auto max-width w-full px-2">
      <v-row>
        <v-col class="py-0" cols="6" sm="3"><router-link to="/privacy">Privace Policy</router-link></v-col>
        <v-col class="py-0" cols="6" sm="3"><router-link to="/licence">Licence</router-link></v-col>
        <v-col class="py-0" cols="6" sm="3"><router-link to="/contact">Contact/Help</router-link></v-col>
        <v-col class="py-0" cols="6" sm="3"><router-link to="/terms-and-conditions">Terms and conditons</router-link></v-col>
      </v-row>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.footer-bg {
  background-color: #f5f5f5;
  border-top: 1px solid lightgray;
  font-size: 12px;
  @media (min-width: 600px) {
    font-size: 14px;
  }
}
a {
  text-decoration: none !important;
  color: black !important;
}
</style>
